import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'
import { OntologyFeature } from './feature/ontologyFeatureTypings'
import { OntologyPredictionCorrection } from './predictionCorrection/ontologyPredictionCorrectionTypings'

export const USE_GET_PROGRAM_ONTOLOGY_KEY = 'program-settings-ontology'

type GetCurrentProgramOntologyConfigResponse = {
  total: number
  features: OntologyFeature[]
  predictionCorrections: OntologyPredictionCorrection[]
  subClassificationFeatures: OntologyFeature[]
}

export function useGetCurrentProgramOntologyConfig(programId?: string, engagementId?: string) {
  return useQuery({
    queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY, programId || '', engagementId || ''],
    queryFn: async () => {
      const url = `/int/v3/programs/${programId}/ontology${engagementId ? `?engagementId=${engagementId}` : ''}`
      const { data } = await apiClient.get<GetCurrentProgramOntologyConfigResponse>(url)
      return data
    },
    enabled: Boolean(programId),
    refetchOnWindowFocus: false,
  })
}
